module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "container mainContent"
  }, [_m(0), " ", _m(1), " ", _m(2), " ", _m(3), " ", _m(4), " ", _m(5), " ", _m(6), " ", _m(7), " ", _m(8), " ", _m(9), " ", _m(10), " ", _m(11), " ", _h('p', [_h('em', ["\n      Card payment facility issues - Contact details:", _m(12), "\n      Postal address: AIDSImpact Conference, Nieuwe Achtergracht 100, 1018 WT Amsterdam", _m(13), "\n      Phone number: 08444849447", _m(14), "\n      Email address (Card payment issues only): ", (true) ? _h('a', {
    attrs: {
      "href": "mailto:WPPCS5@aidsimpact.net"
    }
  }, ["WPPCS5@aidsimpact.net"]) : _e()])])])
}},staticRenderFns: [function (){with(this) {
  return _h('h2', ["Delegate Registration"])
}},function (){with(this) {
  return _h('h3', ["Prices"])
}},function (){with(this) {
  return _h('table', {
    staticClass: "table"
  }, [_h('thead', [_h('tr', [_h('th'), " ", _h('th', {
    staticClass: "text-center"
  }, ["Early bird rates (Ends 28th Feb 2017)"]), " ", _h('th', {
    staticClass: "text-center"
  }, ["Regular rates (Ends 31st Oct 2017)"]), " ", _h('th', {
    staticClass: "text-center"
  }, ["Late / On-site registration (From 1st Nov 2017)"])])]), " ", _h('tbody', [_h('tr', [_h('td', ["Regular participant"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€350"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€450"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€550"])]), " ", _h('tr', [_h('td', ["Low and middle income countries *"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€250"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€250"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€250"])]), " ", _h('tr', [_h('td', ["Student *"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€190"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€190"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€190"])]), " ", _h('tr', [_h('td', ["One day only *"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["-"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€76"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€76"])]), " ", _h('tr', [_h('td', ["Accompanying person *"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€63"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€63"]), " ", _h('td', {
    staticClass: "text-center"
  }, ["€63"])])])])
}},function (){with(this) {
  return _h('p', ["\n    All payment are to be made in Pound sterling (GBP).\n  "])
}},function (){with(this) {
  return _h('ul', [_h('li', ["\n      The Euro (EUR) prices are provided as guides and will vary with exchange rates on the day of payment.\n    "]), " ", _h('li', ["\n      The dates are based on the UK, GMT timezone.\n    "]), " ", _h('li', ["\n      Low-income and middle income economies, as determined by the World Bank.\n    "]), " ", _h('li', ["\n      Student identification must be produced onsite at registration to validate student status.\n    "]), " ", _h('li', ["\n      One day only registration allows access for any single day of your choice.\n    "]), " ", _h('li', ["\n      Accompanying person registration includes Opening and Closing ceremonies and the Welcome reception but no other sessions. Only one accompanying person per registered delegate.\n    "])])
}},function (){with(this) {
  return _h('h3', ["Insurance"])
}},function (){with(this) {
  return _h('p', ["Please note that AIDSImpact cannot be held responsible for any loss, damages or claims that delegates may incur. We advise that all delegates take their own travel and health insurance before travelling to the conference. "])
}},function (){with(this) {
  return _h('h3', ["Cancellation policy:"])
}},function (){with(this) {
  return _h('p', ["\n    Please note that the conference office should be notified of cancellations by e-mail (secretariat@AIDSImpact.com) . Due to financial obligations incurred, 50% of the paid conference fee will be refunded if the conference office receives your written cancellation by email before 1st August 2017. We regret that no refunds can be made for any cancellation received after 2nd August 2017. \n  "])
}},function (){with(this) {
  return _h('p', ["\n    If you cannot attend the conference, you may transfer your registration to another member of your organization at any time. Notification of transfer must be given in writing to the conference office (secretariat@AIDSImpact.com) prior to the conference. \n  "])
}},function (){with(this) {
  return _h('p', ["\n    'No shows' (due to all causes including natural disasters) are non-refundable and are liable for the full registration fee. \n  "])
}},function (){with(this) {
  return _h('hr')
}},function (){with(this) {
  return _h('br')
}},function (){with(this) {
  return _h('br')
}},function (){with(this) {
  return _h('br')
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info_delegateregistration.vue
 ** module id = 91
 ** module chunks = 2
 **/